import ENV from "../env";
import { buildHeaders, handleExpiredLogin } from "./utils";

/** Mirrors the backend's TagAccuracyResponse. */
export type TagAccuracy = {
    tag: string;
    rate: number;
    skippedRate: number;
    answers: number;
};

export class InsideService {
    static tagsRate(topicId: string): Promise<TagAccuracy[]> {
        return fetch(`${ ENV.BACKEND }/inside/${ topicId }/tags-rate`, {
            method: 'GET',
            headers: buildHeaders()
        })
            .then((response) => handleExpiredLogin(response).json());
    }
}
